import React from 'react';
import './style.scss';

export default function ReturningBuyer() {
    return (
        <i className="returning-buyer hint--top" data-hint={i18n.t('reviews.returning_buyer')}/>
    );
}



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/returning_buyer/index.js